import * as Constants from '../constants/redemption';

const initialState = {
  activeRedemption: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_REDEMPTION_SUCCESS:
      return {
        ...state,
        activeRedemption: action.payload,
      };
    case Constants.CLEAR_REDEMPTION:
      return {
        ...state,
        activeRedemption: null,
      };
    case Constants.UPDATE_REDEMPTION_SUCCESS:
      return {
        ...state,
        activeRedemption: action.payload,
      };
    case Constants.DELETE_REDEMPTION_SUCCESS:
      return {
        ...state,
        activeRedemption: null,
      };
    default:
      return state;
  }
};
